export const AdaptiveLearningGeneratedItemDynamic = () =>
  import('bundles/adaptive-learning-item/components/AdaptiveLearningGeneratedItem');
